// Dependency
import React, { useState } from "react";
import { navigate } from 'gatsby';
import Select from 'react-select';

// Internationalization
import i18n from "../../internationalization/i18n";
import { useTranslation } from "react-i18next";
import resources from "../../internationalization/translations";

// Services
import UtilsService from "../../services/utils.service";

// Assets
import france from './assets/france.png'
import sweden from './assets/sweden.png'
import denmark from './assets/denmark-flag.png'
import europe from './assets/europe.png'
import norway from './assets/norway.png'
import netherlands from './assets/netherlands.png'
import unitedKingdom from './assets/uk-flag.png'

// Styles
import * as marketSwitchStyles from './market-switcher.module.scss';

// Template
const MarketSwitcher = ({country}) => {

    const handleChange = (option) => {
        setSelectedOption(option);
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: '50px',
        }),
    };

    // Translation Function
    const { t } = useTranslation();

    const options = [
        { value: 'sweden', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={sweden} alt="Sweden Flag" /><p>{t('switcher.sweden')}</p><span>·</span><span>SEK</span></div>, locale: 'se' },
        { value: 'international', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={europe} alt="Europe Flag" /><p>{t('switcher.international')}</p><span>·</span><span>EURO</span></div>, locale: 'eu' },
        { value: 'denmark', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={denmark} alt="Danish Flag" /><p>{t('switcher.denmark')}</p><span>·</span> <span>DKK</span></div>, locale: 'dk' },
        { value: 'norway', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={norway} alt="Norwegian Flag" /><p>{t('switcher.norway')}</p><span>·</span> <span>NOK</span></div>, locale: 'no' },
        { value: 'netherlands', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={netherlands} alt="Europe Flag" /><p>{t('switcher.netherlands')}</p><span>·</span><span>EURO</span></div>, locale: 'nl' },
        { value: 'uk', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={unitedKingdom} alt="UK Flag" /><p>{t('switcher.uk')}</p><span>·</span><span>GBP</span></div>, locale: 'uk' },
        { value: 'france', label: <div className={marketSwitchStyles.cdMarketSwitcherInput}><img src={france} alt="France Flag" /><p>{t('switcher.france')}</p><span>·</span><span>EURO</span></div>, locale: 'fr' },
    ];

    const [selectedOption, setSelectedOption] = useState(
        options.find((item) => item.locale === country) || options[5]
    );

    const getKeyByValue = (object, value) => {
        return Object.keys(object).find(key => object[key] === value);
    }


    const changeLanguage = (stateItem) => {
        i18n.changeLanguage(stateItem.locale);

        const value = UtilsService.removeLocaleFromUrl().split('/')[1];
        const endSlug = UtilsService.removeLocaleFromUrl().split('/')[2]
        const transObj = resources[UtilsService.getLocaleFromUrl().country]['translation']['slug'];
        const slugKey = getKeyByValue(transObj, value)

        let toURL = '/' + stateItem.locale
        if (slugKey === 'product') {
            toURL = `${toURL}/${resources[stateItem.locale]['translation'].slug.product}/${endSlug}`;
        } else if (value === 'shop') {
            toURL = `${toURL}/shop`;
        } else if (value === 'black-week') {
            toURL = `${toURL}/black-week`;
        } else if (resources[stateItem.locale]['translation'].slug[slugKey] === undefined) {
            toURL = `${toURL}`
        } else {
            toURL = `${toURL}/${resources[stateItem.locale]['translation'].slug[slugKey]}`;
        }
        navigate(toURL);
    };

    return (
        <div className={marketSwitchStyles.cdMarketSwitcherWrapper}>
            <div className={marketSwitchStyles.cdMarketSwitcherTop}>
                <h3>{resources[selectedOption.locale]['translation'].switcher.market}</h3>
            </div>
            <div className={marketSwitchStyles.cdMarketSwitcherRow}>
                <h5>{resources[selectedOption.locale]['translation'].switcher.country}</h5>
                <Select
                    isSearchable={false}
                    className={marketSwitchStyles.cdMarketSwitcherInputWrapper}
                    defaultValue={selectedOption}
                    options={options}
                    styles={customStyles}
                    onChange={(element) => handleChange(element)}
                />
            </div>
            <div className={marketSwitchStyles.cdMarketSwitcherRow}>
                <h5>{resources[selectedOption.locale]['translation'].switcher.terms}</h5>
                <div className={marketSwitchStyles.cdMarketSwitcherTerms}>
                    <div className={marketSwitchStyles.cdMarketSwitcherTerm}>
                        <p><strong>{resources[selectedOption.locale]['translation'].marquee.free} {resources[selectedOption.locale]['translation'].marquee.shipping}</strong></p>
                        <p>{resources[selectedOption.locale]['translation'].switcher.allOrders}</p>
                        <p>{resources[selectedOption.locale]['translation'].switcher.homeDelivery}</p>
                    </div>
                    <div className={marketSwitchStyles.cdMarketSwitcherTerm}>
                        <p><strong>{resources[selectedOption.locale]['translation'].marquee.always} {resources[selectedOption.locale]['translation'].marquee.freePlural} {resources[selectedOption.locale]['translation'].marquee.returns}</strong></p>
                        <p>100 {resources[selectedOption.locale]['translation'].switcher.rightOfReturn}</p>
                    </div>
                    <div className={marketSwitchStyles.cdMarketSwitcherTerm}>
                        <p><strong>{resources[selectedOption.locale]['translation'].switcher.currency}</strong></p>
                        <p>{resources[selectedOption.locale]['translation'].langSwitch.currency}</p>
                    </div>
                </div>
            </div>
            <div className={marketSwitchStyles.cdMarketSwitcherRow}>
                <button
                    onClick={() => { changeLanguage(selectedOption) }}
                    className={`${marketSwitchStyles.cdButton} button`}>{resources[selectedOption.locale]['translation'].switcher.change}
                </button>
                <div className={marketSwitchStyles.cdMarketSwitcherLink}>
                </div>
            </div>
        </div>
    )

}
export default MarketSwitcher;